/**
 * Copies the full URL for a given path to the clipboard.
 * @param path - Path segment (e.g. `/agent-builder/123` or `agent-builder/123`)
 * @returns Promise that resolves when the copy succeeds, or rejects on failure
 */
export function copyPageUrlToClipboard(path: string): Promise<void> {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${window.location.origin}${normalizedPath}`;
  return navigator.clipboard.writeText(url);
}
